export default "__VITE_ASSET__ChSCi$vY__"